<div>
  @if (addendumLogs().length > 0) {
    <div>
      <div class="d-flex flex-column gap-4">
        @for (log of addendumLogs(); track log.id) {
          <div class="card rounded-4 overflow-hidden">
            <div class="card-header bg-white">
              <div class="d-flex align-items-center gap-3">
                <div class="user-30">
                  <name-initials [data]="log.userName"></name-initials>
                </div>
                <div>
                  <h3 class="fs-18 m-0">{{ log.userName }}</h3>
                  <span class="fs-14">
                    <i class="bi bi-clock me-1 lh-1"></i>
                    {{ log.createdAt | date: 'MM/dd/yyyy, h:mm a' }}
                  </span>
                </div>
                <span class="badge bg-success-subtle fw-500 text-bg-light ms-auto">Updated</span>
              </div>
            </div>
            <div class="card-body bg-light">
              <div class="row gy-3 fs-14">
                <div class="col-md-6">
                  <span class="fw-500 d-block">Activity Type:</span>
                  {{ log.activityType }}
                </div>
                @for (item of log.additionalInfos; track $index) {
                  <div class="col-md-6">
                    <span class="fw-500 d-block">{{ item.key }}:</span>
                    @if (isDate(item)) {
                      {{ item.value | date: 'MM/dd/yyyy, h:mm a' }}
                    } @else {
                      {{ item.value }}
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  } @else {
    <div class="text-center py-5 text-muted">
      <p>No logs history available</p>
    </div>
  }
</div>
